var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 263,
    height: 211,
    viewBox: "0 0 263 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_target_illustration 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.18,
    d: "M227.933 105.5C227.933 149.199 192.609 184.625 149.033 184.625C105.458 184.625 70.1333 149.199 70.1333 105.5C70.1333 61.8004 105.458 26.3749 149.033 26.3749C192.609 26.3749 227.933 61.8004 227.933 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.18,
    d: "M210.4 105.5C210.4 139.488 182.925 167.042 149.033 167.042C115.141 167.042 87.6667 139.488 87.6667 105.5C87.6667 71.5114 115.141 43.9582 149.033 43.9582C182.925 43.9582 210.4 71.5114 210.4 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.18,
    d: "M192.867 105.5C192.867 129.777 173.242 149.458 149.033 149.458C124.825 149.458 105.2 129.777 105.2 105.5C105.2 81.2224 124.825 61.5416 149.033 61.5416C173.242 61.5416 192.867 81.2224 192.867 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.18,
    d: "M175.333 105.5C175.333 120.066 163.558 131.875 149.033 131.875C134.508 131.875 122.733 120.066 122.733 105.5C122.733 90.9334 134.508 79.1249 149.033 79.1249C163.558 79.1249 175.333 90.9334 175.333 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.18,
    d: "M158.677 105.5C158.677 110.841 154.359 115.171 149.033 115.171C143.707 115.171 139.39 110.841 139.39 105.5C139.39 100.159 143.707 95.8291 149.033 95.8291C154.359 95.8291 158.677 100.159 158.677 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.18,
    d: "M150.348 105.5C150.348 106.228 149.76 106.819 149.033 106.819C148.307 106.819 147.718 106.228 147.718 105.5C147.718 104.772 148.307 104.181 149.033 104.181C149.76 104.181 150.348 104.772 150.348 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.18,
    d: "M35.0667 39.5624L149.033 105.5",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.18,
    d: "M142.458 101.983L149.033 105.5L145.527 98.9061",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.18,
    d: "M32.875 48.3541L30.6833 35.1666L43.8333 32.9686M30.6833 35.1666L40.3267 43.9582",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.18,
    d: "M149.033 26.3749C169.959 26.3749 190.027 34.7112 204.824 49.5501C219.621 64.3889 227.933 84.5146 227.933 105.5",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.18,
    d: "M52.6 167.042V131.875L74.5167 138.469L56.9833 145.062",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.18,
    d: "M227.933 167.042C227.933 171.897 224.008 175.833 219.167 175.833C214.325 175.833 210.4 171.897 210.4 167.042C210.4 162.186 214.325 158.25 219.167 158.25C224.008 158.25 227.933 162.186 227.933 167.042Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.18,
    d: "M215.222 167.042H223.112",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetMobile);
export default __webpack_public_path__ + "static/media/target-mobile.e98495b8dfba6e1c2bdca26f2c90bdb2.svg";
export { ForwardRef as ReactComponent };